import { Modal } from '@components/modal/Modal';
import { FloorPlanData, FloorPlanTableData } from '@shared/types/floorPlans';
import type { BookingUnit } from '@shared/types/restaurants';
import cx from 'classnames';
import typography from '~styles/typography.scss';
import { type TierTablePricing } from './apiHelpers';
import { getBookingUnitLabels } from '@shared/restaurantEvents/bookingUnitLabels';
import { TableSelectionFields } from './TableSelectionFields';
import styles from './RestaurantEventTiersList.scss';

interface TableSelectionModalProps {
  isOpen: boolean;
  onClose: () => void;
  floorPlans: FloorPlanData[];
  selectedFloorPlanId: string | undefined;
  onSelectFloorPlanId: (floorPlanId: string) => void;
  availableTables: TierTablePricing[];
  selectedFloorPlanTable: FloorPlanTableData | undefined;
  onSelectTable: (table: FloorPlanTableData) => void;
  onConfirm: (selectedFloorPlanTable: FloorPlanTableData) => void;
  onSkip: () => void;
  guestCount: number;
  bookingUnit: BookingUnit;
}

export const TableSelectionModal = ({
  isOpen,
  onClose,
  ...fieldsProps
}: TableSelectionModalProps) => {
  const { unitLabelCapitalized } = getBookingUnitLabels(
    fieldsProps.bookingUnit,
  );

  return (
    <Modal
      ariaLabel={`Optional ${unitLabelCapitalized} Selection Modal`}
      isOpen={isOpen}
      onClose={onClose}
    >
      <div className={styles.tableSelectionModalContent}>
        <div className={cx(typography.h4)}>
          Upgrade Your {unitLabelCapitalized}
        </div>
        <TableSelectionFields {...fieldsProps} />
      </div>
    </Modal>
  );
};
